export default __webpack_public_path__ + "static/media/mode-60.1abf60b8.svg";